/** Mirrors `apps/automotive-api/src/auth/roles.ts` — keep in sync. */
export const ROLES = ['SUPER_ADMIN', 'STAFF'] as const
export type Role = (typeof ROLES)[number]

export const NO_ROLE = 'NONE' as const
export type NoRole = typeof NO_ROLE

export type ParsedRole = Role | NoRole

export const ROLE = {
  SUPER_ADMIN: 'SUPER_ADMIN',
  STAFF: 'STAFF',
  NONE: 'NONE',
} as const satisfies Record<string, ParsedRole>

const ROLE_SET = new Set<string>(ROLES)

export function parseRole(raw: unknown): ParsedRole {
  if (typeof raw !== 'string' || !raw.trim()) {
    return ROLE.NONE
  }
  if (ROLE_SET.has(raw)) {
    return raw as Role
  }
  return ROLE.NONE
}

export function isRole(value: string): value is Role {
  return ROLE_SET.has(value)
}

export function isSuperRole(role: ParsedRole): boolean {
  return role === ROLE.SUPER_ADMIN
}

export function isStaff(role: ParsedRole): boolean {
  return role === ROLE.STAFF
}
